export default __webpack_public_path__ + "static/media/large.0dd286c6.jpg";